import { useRenderKey } from '@casops/hooks/useRenderKey';
import { useListAssetGroupsQuery } from '@casops/store/apis/assetGroupsApi';
import { useListGeofenceAreasQuery } from '@casops/store/apis/geofenceAreasApi';
import { useListGeofenceHoldTimesQuery } from '@casops/store/apis/geofenceHoldTimesApi';
import { GeofenceModel } from '@casops/store/apis/geofencesApi';
import { useListGeofenceStylesQuery } from '@casops/store/apis/geofenceStylesApi';

interface Props {
  isItemLoaded: boolean;
  item?: GeofenceModel;
}

interface Return {
  renderKey: string;
  isLoaded: boolean;
}

// Load form dependencies.
export const useLoadGeofenceDataDependencies = ({ isItemLoaded, item }: Props): Return => {
  const { data: assetGroups, isSuccess: isSuccessAssetGroups } = useListAssetGroupsQuery(
    undefined,
    {
      refetchOnMountOrArgChange: 60,
    },
  );
  const { data: areas, isSuccess: isSuccessAreas } = useListGeofenceAreasQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });
  const { data: geofenceStyles, isSuccess: isSuccessStyles } = useListGeofenceStylesQuery(
    undefined,
    {
      refetchOnMountOrArgChange: 120,
    },
  );
  const { data: holdTimes, isSuccess: isSuccessHoldTimes } = useListGeofenceHoldTimesQuery(
    undefined,
    {
      refetchOnMountOrArgChange: 120,
    },
  );

  // The renderKey must update whenever any dependency data changes.
  const renderKey = useRenderKey({ item, assetGroups, areas, geofenceStyles, holdTimes });

  const isLoaded = [
    isItemLoaded,
    isSuccessAssetGroups,
    assetGroups,
    isSuccessAreas,
    areas,
    isSuccessStyles,
    geofenceStyles,
    isSuccessHoldTimes,
    holdTimes,
  ].every(Boolean);

  return {
    renderKey,
    isLoaded,
  };
};
